module.exports = __webpack_public_path__ + "img/app-icon-toolbox-dark.a6c420b2.svg";